export default __webpack_public_path__ + "static/home-848d9a779221100bd21729c75d701e8a.png";